// Shared milestone-derivation primitives. `isSet` (a non-empty-string type
// guard) was defined verbatim in four derive* utils, and the MilestoneInput
// shape twice. Centralised here so the derivation helpers single-source
// them. The canonical timestamp interface still lives in
// deriveMilestoneStatus; this leaf takes a type-only reference so it adds
// no runtime export to that (widely vi.mock'd) module.

import type { MilestoneLifecycleTimestamps } from "./deriveMilestoneStatus";

/** True when the value is a present, non-empty string. */
export const isSet = (v: string | null | undefined): v is string =>
  typeof v === "string" && v.length > 0;

/** Lifecycle timestamps plus the planned date — the input shape the
 *  display/gate derivations operate on. */
export type MilestoneInput = {
  plannedDate?: string | null;
} & MilestoneLifecycleTimestamps;
